import { alphabeticalSort, compareNumbers } from "@sveabank/cc-common";
import { useFetchCountriesQuery } from "../services/application";
import { getApplicationLanguage } from "../utils/storage";

export const useCountries = () => {
	const { data, isError, isLoading } = useFetchCountriesQuery();

	const languageSetting = getApplicationLanguage();

	const sortedCountriesByName = data
		?.concat()
		.sort((a, b) => alphabeticalSort(a.names[languageSetting], b.names[languageSetting]));

	const sortedCountriesByCallingCode = data
		?.concat()
		.sort((a, b) =>
			compareNumbers(
				Number.parseFloat(a.callingCodes?.[0] ?? ""),
				Number.parseFloat(b.callingCodes?.[0] ?? ""),
			),
		);

	const eesCountries = sortedCountriesByName?.filter((item) => item.partOfEes);

	const nonEesCountries = sortedCountriesByName?.filter((item) => !item.partOfEes);

	const countriesWithInternationalPayments = sortedCountriesByName?.filter(
		(item) => item.internationalPayment,
	);

	const countriesWithoutInternationalPayments = sortedCountriesByName?.filter(
		(item) => !item.internationalPayment,
	);

	const countriesEesAndInternationalPayments = sortedCountriesByName?.filter(
		(item) => item.internationalPayment && item.partOfEes,
	);

	return {
		allCountries: data,
		sortedCountriesByName,
		eesCountries,
		nonEesCountries,
		countriesWithInternationalPayments,
		countriesWithoutInternationalPayments,
		countriesEesAndInternationalPayments,
		isError,
		isLoading,
		sortedCountriesByCallingCode,
	};
};
